import { render, staticRenderFns } from "./WexRedirect.vue?vue&type=template&id=477c97fc"
import script from "./WexRedirect.vue?vue&type=script&lang=ts"
export * from "./WexRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports